{
  "title": "Profil",
  "logout": "Logga ut",
  "logout_failed": "Det gick inte att logga ut. Försök igen.",
  "restore_purchases": "Återställ köp",
  "restore_purchases_hint": "Installerat om appen eller bytt enhet?",
  "restore_purchases_mismatch_title": "Prenumerationen är kopplad till ett annat konto",
  "restore_purchases_mismatch_message": "Det här köpet tillhör ett annat konto. Logga in med det ursprungliga kontot för prenumerationen och försök igen.",
  "restore_purchases_failed": "Det gick inte att återställa köp.",
  "manage_subscription": "Hantera prenumeration",
  "subscribe": "Börja prenumerera",
  "subscription_ends_in_days_one": "Avslutas om {{count}} dag",
  "subscription_ends_in_days_other": "Avslutas om {{count}} dagar",
  "subscription_ends_in_hours_one": "Avslutas om {{count}} timme",
  "subscription_ends_in_hours_other": "Avslutas om {{count}} timmar",
  "subscription_ends_in_minutes_one": "Avslutas om {{count}} minut",
  "subscription_ends_in_minutes_other": "Avslutas om {{count}} minuter",
  "subscription_ends_soon": "Avslutas snart",
  "version_label": "Version",
  "version_accessibility_label": "Version {{version}}",
  "developer_mode_label": "Utvecklarläge",
  "developer_mode_enabled_title": "Utvecklarläge aktiverat",
  "developer_mode_enabled_message": "Påminnelsen om röstbedömning visas alltid.",
  "developer_mode_disabled_title": "Utvecklarläge inaktiverat",
  "developer_mode_disabled_message": "Påminnelsen om röstbedömning följer sitt vanliga schema.",
  "developer_mode_update_failed": "Det gick inte att uppdatera utvecklarläget. Försök igen.",
  "language": "Språk",
  "language_en": "Engelska",
  "language_sv": "Svenska",
  "change_language": "Byt språk",
  "restored_success": "Köp återställda.",
  "no_subscriptions_title": "Inga prenumerationer",
  "no_subscriptions_message": "Vi kan inte hantera prenumerationen. Mejla support@vocalise.app om du behöver hjälp.",
  "subscription_link_hint_ios": "Öppnas i App Store",
  "subscription_link_hint_android": "Öppnas i Google Play",
  "subscription_link_hint_web": "Öppnas i webbläsaren",
  "end_subscription_failed": "Det gick inte att öppna prenumerationshantering. Försök igen.",
  "anonymous_user": "Användare",
  "remove_account": "Ta bort konto",
  "remove_account_confirm_title": "Ta bort konto?",
  "remove_account_confirm_message": "Detta raderar permanent ditt konto och all tillhörande data. Denna åtgärd kan inte ångras.",
  "remove_account_final_confirm": "Ja, ta bort mitt konto",
  "remove_account_success": "Ditt konto har tagits bort.",
  "remove_account_failed": "Det gick inte att ta bort kontot. Försök igen.",
  "remove_account_blocked_title": "Aktiv prenumeration",
  "remove_account_blocked_message": "Du måste avsluta din prenumeration innan du kan ta bort ditt konto. Vänligen avsluta prenumerationen via länken nedan och kom sedan tillbaka och försök igen.",
  "remove_account_unsubscribe_ios": "Hantera prenumerationer i App Store",
  "remove_account_unsubscribe_web": "Hantera prenumeration",
  "remove_account_unsubscribe_android": "Hantera prenumerationer i Google Play",
  "remove_account_unsubscribe_hint_ios": "Öppnas i App Store",
  "remove_account_unsubscribe_hint_web": "Öppnas i webbläsaren",
  "remove_account_unsubscribe_hint_android": "Öppnas i Google Play",
  "remove_account_refresh_status": "Jag har avslutat — Kontrollera igen",
  "email_not_verified_title": "E-post inte verifierad",
  "email_not_verified_message": "Verifiera din e-postadress för att säkra ditt konto.",
  "resend_verification_email": "Skicka verifieringsmail igen",
  "waiting_for_verification": "Väntar på verifiering...",
  "resend_verification_success_title": "Verifieringsmail skickat",
  "resend_verification_success_message": "Kolla din inkorg på {{email}}.",
  "resend_verification_failed": "Det gick inte att skicka verifieringsmail. Försök igen.",
  "edit_name": "Ändra namn",
  "edit_name_description": "Det här är namnet som visas i appen.",
  "edit_name_placeholder": "Ange ditt namn",
  "edit_name_empty_error": "Namn kan inte vara tomt.",
  "edit_name_success": "Ditt namn har uppdaterats.",
  "edit_name_failed": "Det gick inte att uppdatera namnet. Försök igen.",
  "report_issue_settings_label": "Rapportera ett problem",
  "report_issue_settings_hint": "Skicka diagnostik",
  "report_issue_heading": "Berätta vad som hände",
  "report_issue_description": "Beskriv problemet och vad du försökte göra. Vi inkluderar app-, enhets-, sid- och anslutningsinformation så att rapporten blir enklare att undersöka.",
  "report_issue_linked_event_title": "Kopplat till en felrapport",
  "report_issue_linked_event_message": "Din feedback kopplas till referens {{eventId}}.",
  "report_issue_message_label": "Vad gick fel?",
  "report_issue_message_placeholder": "Beskriv vad som hände och vad du försökte göra.",
  "report_issue_name_label": "Namn (valfritt)",
  "report_issue_name_placeholder": "Ditt namn",
  "report_issue_email_label": "E-post (valfritt)",
  "report_issue_email_placeholder": "du@example.com",
  "report_issue_message_min_length": "Skriv minst {{count}} tecken.",
  "report_issue_sentry_disabled": "Problemrapporter skickas bara från versioner där diagnostik är aktiverad.",
  "report_issue_submit_failed": "Det gick inte att skicka rapporten. Försök igen.",
  "report_issue_submit": "Skicka rapport",
  "report_issue_success_title": "Rapport skickad",
  "report_issue_success_message": "Tack. Vi har tagit emot din rapport och diagnostik.",
  "test_store_title": "Testbutik - simulerade köp",
  "test_store_message": "Det går inte att hantera prenumerationen i testbutiken. Vänligen kontakta support@vocalise.app om du behöver hjälp.",
  "can_not_manage_subscription": "Det går inte att hantera prenumerationen. Vänligen kontakta support@vocalise.app om du behöver hjälp."
}
